/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { useSelector } from 'react-redux';
import Decimal from 'decimal.js';

const standardError =
  '* estimate has a relative standard error of 25% to 50% and should be used with caution';
const standardErrorHigh =
  '** estimate has a relative standard error greater than 50% and is considered too unreliable for general use';

export default function Annotation() {
  const curData = useSelector((state) => state.data.curData);
  const incomeSelectActive = useSelector(
    (state) => state.data.incomeSelectActive,
  );
  const type = useSelector((state) => state?.data?.type);
  const sex = useSelector((state) => state?.data?.sex);
  const incomeLevel = useSelector((state) => state?.data?.incomeLevel);
  const earnLess = useSelector((state) => state?.data?.earnLess);
  const earnMore = useSelector((state) => state?.data?.earnMore);
  const timeframe = useSelector((state) => state?.data?.timeframe);

  const indicatorIndex = curData.findIndex((d) => d.iID === incomeLevel);
  const curObject = curData[indicatorIndex];

  function roundto1dp(num) {
    return Number(new Decimal(num).toFixed(1));
  }

  console.log('curData ', curData);
  console.log('incomeLevel ', incomeLevel);
  const curDataObject = curData.find((obj) => obj.iID === incomeLevel);
  console.log(curDataObject);

  function getStandardError() {
    if (!incomeSelectActive) {
      return '';
    }

    if (curObject.dataStatus === '*') {
      return (
        <div className="standard-error">
          <strong>NOTE:</strong> {standardError}
        </div>
      );
    }

    if (curObject.dataStatus === '**') {
      return (
        <div className="standard-error">
          <strong>NOTE:</strong> {standardErrorHigh}
        </div>
      );
    }

    return '';
  }

  function getAnnotationString() {
    if (!incomeSelectActive) {
      return '';
    }

    console.log('curDataObject ', curDataObject);
    const num = (curDataObject.total * 1000).toLocaleString();
    const sexString =
      sex === 'male'
        ? 'males'
        : sex === 'female'
          ? 'females'
          : 'males and females';

    const typeString =
      type === 'all' ? 'full-time and part-time workers' : type;

    const timeframeValue =
      timeframe === 'annual' ? curDataObject.annual : curDataObject.weekly;

    const timeframeString = timeframe === 'annual' ? 'year' : 'week';

    /* const sentenceA = `${
      curObject.dataStatus
    }There are ${num} ${sexString} in ${typeString} emplyoment, earning between ${timeframeValue} a ${timeframeString}, making up ${roundto1dp(
      curDataObject.diff,
    )}% of the selected population.`; */

    return (
      <div className="annoation-helper">
        {curObject.dataStatus} There were <strong>{num}</strong> {sexString} in{' '}
        {typeString} emplyoment, earning between{' '}
        <strong>{timeframeValue}</strong> a {timeframeString}, making up{' '}
        <strong>{roundto1dp(curDataObject.diff)}%</strong> of the selected
        population.
        {getStandardError()}
      </div>
    );
  }

  return <>{getAnnotationString()}</>;
}
